import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet'
import { injectIntl } from 'react-intl'
import { createStructuredSelector } from 'reselect'
import { selectStaff, selectedStaffData } from 'redux/staff/selectors'
import StaffAction from 'redux/staff/actions'
import { Typography } from 'antd'
import * as moment from 'moment'
import BirthDayFollowup from './BirthDayFollowup'


const { Text } = Typography

const mapStateToProps = () =>
  createStructuredSelector({
    staff: selectStaff,
    selectedStaff: selectedStaffData,
  })

const StaffList = ({
  selectedStaff,
  intl: { formatMessage },
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({
      type: StaffAction.LOAD_ALL,
    })
  }, [dispatch])

  console.log("selectedStaff",selectedStaff)

  // const currentDate = new Date()

  const currentDateFormat = moment(new Date()).format('MM-DD')

  console.log("currentDateFormat",currentDateFormat)
  console.log("selectedStaff",selectedStaff)

  const birthDayFiltered = selectedStaff?.filter(
    item => moment(item.dob).format('MM-DD') === currentDateFormat,
  )

  return (
    <div>
      <Helmet title={formatMessage({ id: 'title.helmet.Dashboard' })} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <h5 className="mb-4">
                <strong>{formatMessage({ id: 'text.TodayBirthDay' })}</strong>
                &nbsp;&nbsp;
                <Text className="font-size-16 font-weight-bold" code>
                  {formatMessage(
                    { id: 'text.totalCount' },
                    { count: birthDayFiltered?.length || 0 },
                  )}
                </Text>
              </h5>
              <BirthDayFollowup infoData={birthDayFiltered} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(injectIntl(StaffList))
